import React from "react";
import { useNavigate } from "react-router-dom";
import { calculateAge, formatDate } from "../../_helper/utils/utils";

const PrescriptionCard = ({ prescription }) => {
  const navigate = useNavigate();

  // console.log("Precription", prescription);

  const renderPriorityTag = (priority) => {
    const colors = {
      High: "bg-red-100 text-red-800",
      Medium: "bg-orange-100 text-orange-800",
      Low: "bg-green-100 text-green-800",
    };
    return (
      <span
        className={`inline-block px-3 py-1 text-xs sm:text-sm font-medium rounded ${prescription.status === "draft" ? colors["Medium"] : colors["Low"]}`}
      >
        {prescription.status === "draft" ? "Pending" : "Completed"}
      </span>
    );
  };

  return (
    <div
      className="bg-white rounded-lg shadow-lg p-3 sm:p-4 border-l-4"
      style={{
        borderColor:
          prescription.priority === "High"
            ? "red"
            : prescription.priority === "Medium"
              ? "orange"
              : "green",
      }}
    >
      <h3 className="text-lg font-semibold text-gray-800 mb-1">
        {prescription.patient_id.full_name} ({prescription?.patient_id?.gender})
      </h3>

      <p className="text-sm text-gray-600">
        <strong>Patient ID:</strong> PA{prescription?.patient_id?.id}
      </p>
      <p className="text-sm text-gray-600">
        <strong>Age:</strong> {calculateAge(prescription?.patient_id.dob).years}
      </p>
      <p className="text-sm text-gray-600">
        <strong>Mobile:</strong> {prescription?.patient_id?.phone}
      </p>
      <p className="text-sm text-gray-600">
        <strong>Department:</strong> {"Pharmacy"}
      </p>
      <p className="text-sm text-gray-600">
        <strong>Date:</strong> {formatDate(prescription?.date_created)}
      </p>
      <div className="mt-2">{renderPriorityTag(prescription?.priority)}</div>
      <div className="text-right mt-4">
        <button
          onClick={() =>
            navigate(
              `/new/pharmacy/prescription/${prescription.id}?p=${prescription?.patient_id?.id}`
            )
          }
          className="text-green-600 hover:text-green-800 text-sm font-medium underline"
        >
          View Details →
        </button>
      </div>
    </div>
  );
};

export default PrescriptionCard;
